export const Checkbox = `
    <Checkbox
        id='checkbox-1' // String (Required)
        label='Checkbox label' // Any
        name='checkbox-1' // String
        description='Description for checkbox' // String
        value='checkbox-1' // Any
        isDisabled={false} // Boolean: true, false (by default)
        isChecked={isChecked} // Boolean: true, false (by default)
        isInvalid={isInvalid} // Boolean: true, false (by default)
        invalidLabel='You need to check this box to continue' // String (Depends on IsInvalid)
        className='custom-class' // String
        onChange={handleChange} // () => {}
    />
`

export const CheckboxList = `
    const checkboxes = [
        {
            id: "custom-checkbox-0",
            label: "Label for Checkbox",
            name: "checkbox",
            description: "Description for checkbox",
            value: "check-box-value",
            checked: false,
            disabled: false
        },
        {
            id: "custom-checkbox-1",
            label: "Label for Checkbox",
            name: "checkbox",
            description: "Description for checkbox",
            value: "check-box-value",
            checked: false,
            disabled: false
        }
    ]

    const [checkedState, setCheckedState] = useState( new Array(checkboxes.length).fill(false) );    
    const handleOnChange = (position: any) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item )
        setCheckedState(updatedCheckedState)
    }

    {checkboxes.map(({ id, label, name, description, value, disabled }, index) => {
        return (
            <Checkbox
                id={id}
                label={label}
                name={name}
                description={description}
                value={value}
                isDisabled={disabled}
                isChecked={checkedState[index]}
                className='custom-class'
                onChange={ () => { handleOnChange(index) } }
            />
        );
    })}
`
